<template>
    <div>
        {{ message }}
    </div>
</template>

<script>

import api from "@/repo/api";

export default {
    name: "Auth",
    data() {
        return {
            //code=9f8757bd8ec44414bda5f1e0887ee2f4
            code: '',
            message: '授权中，请稍后...'
        }
    },
    mounted() {
        this.code = this.$route.query.code;
        
        this.auth()
        // this.fail()
    },
    methods: {
        auth() {
            
            if (!this.code) return this.fail()
            
            this.$loading.show()
            
            api.post('/ast-vip/code-auth', {code: this.code}).then(res => {
                
                this.$loading.hide();
                
                if (res.code !== 0) {
                    return this.fail(res.msg);
                }
                
                this.$message.success('授权成功');
                
                this.$router.push('/ast/setting/vip')
            })
            
        },
        fail(msg) {
            this.$message.error(msg || '授权失败，请重新授权')
            //this.$router.push('/ast/setting/vip')
        }
    }
}
</script>

<style scoped lang="scss">

</style>